import { SIGNAL_WIDGET_ROOT_ID } from "../constants/signalWidget";

// Полный демонтаж внешнего чат-виджета «Сигнал».
//
// Вызываем SDK.destroy(), а затем на всякий случай сами убираем корневой узел и
// тег скрипта: SDK не всегда чистит DOM, из-за чего при выкидывании на /login
// (протух JWT) виджет продолжал жить и работать без входа в ЛК до перезагрузки
// страницы. Функция идемпотентна — безопасно звать повторно.
export function teardownSignalWidget(): void {
  try {
    window.SignalWidget?.destroy();
  } catch (error) {
    console.error("Signal widget destroy failed: ", error);
  }
  document.getElementById(SIGNAL_WIDGET_ROOT_ID)?.remove();
  document.querySelector("script[data-signal-widget]")?.remove();
}
